import React from 'react';

export function SchoolIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 48 48"
      {...props}
    >
      <path d="M24.479 6.261a1 1 0 00-.958 0l-19.91 10.86a1 1 0 000 1.757l5.868 3.198a1 1 0 01.521.878v10.813a1 1 0 00.521.877l13 7.095a1 1 0 00.958 0l13-7.095a1 1 0 00.521-.877V22.953a1 1 0 01.522-.878L42 20.18V33a1 1 0 001 1h2a1 1 0 001-1V18.594a1 1 0 00-.521-.878l-21-11.455zM37.64 18l-13.161 7.179a1 1 0 01-.958 0L10.36 18l13.161-7.179a1 1 0 01.958 0L37.64 18zM34 31.387a1 1 0 01-.52.877l-9 4.914a1 1 0 01-.96 0l-9-4.914a1 1 0 01-.52-.877V24.54l9.52 5.198a1 1 0 00.96 0L34 24.54v6.847z" />
    </svg>
  );
}
